import { Form, Radio, Typography } from 'antd'
import React from 'react'
import { CommonClient } from '~/agents/common/client'
import { OnboardingValues } from '~/agents/legalAssistant/common'
import { SelectProviderAccount } from '~/features/formConfiguration/client/components/CustomInputs/SelectProviderAccount'
import { TitlePrimary } from '~/features/shared/components'
import { StepProps } from '../types'

type Props = StepProps

export const StepConnection: React.FC<Props> = props => {
  return (
    <>
      <CommonClient.Onboarding.Step {...props}>
        <TitlePrimary level={4}>Connect Your Drive</TitlePrimary>

        <Typography.Text type="secondary" className="mb-10">
          Don't worry — in the next step, you'll be able to choose exactly which
          files you want to share from your Google Drive
        </Typography.Text>

        <Form.Item
          name={['fileServices', 'provider']}
          label="Which provider do you use?"
          rules={[{ required: true }]}
        >
          <Radio.Group
            optionType="button"
            buttonStyle="solid"
            options={[
              {
                label: 'Google Drive',
                value: 'googleDrive',
              },
              {
                label: 'Microsoft OneDrive',
                value: 'oneDrive',
              },
            ]}
          />
        </Form.Item>

        <Form.Item<OnboardingValues> shouldUpdate={true}>
          {options => {
            const provider = options.getFieldValue(['fileServices', 'provider'])

            if (provider === 'googleDrive') {
              return (
                <Form.Item
                  name={['fileServices', 'accountGoogleDrive']}
                  label="Google Drive Account"
                  rules={[{ required: true }]}
                >
                  <SelectProviderAccount providerKey="googleDrive" />
                </Form.Item>
              )
            }

            if (provider === 'oneDrive') {
              return (
                <Form.Item
                  name={['fileServices', 'accountOneDrive']}
                  label="OneDrive Account"
                  rules={[{ required: true }]}
                >
                  <SelectProviderAccount providerKey="oneDrive" />
                </Form.Item>
              )
            }
          }}
        </Form.Item>
      </CommonClient.Onboarding.Step>
    </>
  )
}
